import VehicleChecksView from "./views/VehicleChecksView.vue";

const authRoutes = [
    {
        path: '/checks',
        component: VehicleChecksView,
        name: 'Checks',
        meta: { requiresAuth: true },

    }
]

export default router => {
    authRoutes.forEach(route => {
        router.addRoute(route);
    });
}